/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo {
    /**
     * 
     * @type {any}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo
     */
    UserPayload?: any | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo {
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'UserPayload': json['UserPayload'] == null ? undefined : json['UserPayload'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'UserPayload': value['UserPayload'],
    };
}

